import { Reducer } from "redux";
import { Action, ActionType } from "../../../actions";
import { FiltersData } from "../../../state/BookingCreateManager/SSR/FiltersData";

const updateFiltersData: Reducer<FiltersData> = (state: FiltersData = new FiltersData(), action: Action<ActionType, FiltersData>) => {
  switch (action.type) {
    case ActionType.BOOKING_CREATE_MANAGER_SSR_FILTERS_DATA_UPDATED:
      return { ...state, ...action.data };
    case ActionType.BOOKING_CREATE_MANAGER_SSR_FILTERS_DATA_RESET:
      return new FiltersData();
    default:
      return state;
  }
};

export default updateFiltersData;
